import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import {
  getAggregatedData,
  getAggregatedDataWrapper,
  onFilterModelChange,
  renderGrid,
  aggregatedAdministrativeTableColumns,
} from "./AgroAnalyticsUtils";
import i18n from "i18next";

const aggregatedSpecieTableColumns = () => [
  {
    field: "Anno",
    headerName: i18n.t("agriculture.year"),
    width: 60,
  },

  {
    field: "Compagnia",
    headerName: i18n.t("company"),
    width: 60,
  },

  {
    field: "Specie",
    headerName: "Specie",
    width: 120,
  },
  {
    field: "Specie_Group",
    headerName: "Specie Group",
    width: 120,
  },
  ...aggregatedAdministrativeTableColumns(),
];

export const AgroSpecieGrid = ({ filterModel, wantedReferenceDateProp }) => {
  const { t } = useTranslation();

  const [aggregatedSpecieTableState, setAggregatedSpecieTableState] = useState({
    isLoading: false,
    total: 0,
  });

  const aggregatedSpecieCancelTokenRef = useRef(null);

  const [aggregatedSpecieTableData, setAggregatedSpecieTableData] = useState([]);

  useEffect(() => {
    const getAggregatedSpecieData = async () => {
      return await getAggregatedData(
        setAggregatedSpecieTableState,
        setAggregatedSpecieTableData,
        { aggr: "Specie" },
        filterModel,
        wantedReferenceDateProp,
        aggregatedSpecieCancelTokenRef,
      );
    };
    const getAggregatedSpecieDataWrapper = async () => {
      getAggregatedDataWrapper(aggregatedSpecieCancelTokenRef, getAggregatedSpecieData);
    };
    onFilterModelChange(filterModel, getAggregatedSpecieDataWrapper);
  }, [filterModel, wantedReferenceDateProp]);

  return renderGrid(
    aggregatedSpecieTableColumns(),
    aggregatedSpecieTableData,
    aggregatedSpecieTableState,
    t,
    "Agenzie",
  );
};
